import ga from './../../vendor/google-analytics'

window.globalGA = ga;

export default {}